import apiClient from './apiClient';

const settingsService = {
  /**
   * Get workshop settings (authenticated)
   */
  getSettings: async () => {
    const response = await apiClient.get('/settings');
    return response.data;
  },

  /**
   * Update workshop settings (admin only)
   */
  updateSettings: async (settings) => {
    const response = await apiClient.put('/settings', settings);
    return response.data;
  },

  /**
   * Update logo (admin only)
   */
  updateLogo: async (logoBase64) => {
    const response = await apiClient.put('/settings/logo', { logo: logoBase64 });
    return response.data;
  },

  /**
   * Get public settings (no auth required)
   */
  getPublicSettings: async () => {
    const response = await apiClient.get('/public/settings');
    return response.data;
  },
};

export default settingsService;
